<script setup lang="ts">
import { ref } from "vue";
import {getCmsElementsFromCategory} from "~/server/apiBuilder";
const route = useRoute();

const layoutId = "01933e7bea3073bea6a2a93e66da5f6e"

let cmsElementsFromCategory = ref();

cmsElementsFromCategory = await getCmsElementsFromCategory(layoutId);


</script>
<template>
  <CmsPage v-if="cmsElementsFromCategory?.cmsPage" :content="cmsElementsFromCategory.cmsPage" />
</template>